import { isSymbol as F, extend as le, hasChanged as x, isFunction as k, isArray as T, EMPTY_OBJ as Fe, isObject as H, NOOP as Ge, remove as Je, isSet as Ue, isMap as j, isPlainObject as Qe, hasOwn as ee, def as qe, toRawType as De, isIntegerKey as _e, makeMap as Xe, capitalize as Ze } from "../../../../../@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
/**
* @vue/reactivity v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function R(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let g;
class ke {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = g, !t && g && (this.index = (g.scopes || (g.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, s;
      if (this.scopes)
        for (t = 0, s = this.scopes.length; t < s; t++)
          this.scopes[t].pause();
      for (t = 0, s = this.effects.length; t < s; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, s;
      if (this.scopes)
        for (t = 0, s = this.scopes.length; t < s; t++)
          this.scopes[t].resume();
      for (t = 0, s = this.effects.length; t < s; t++)
        this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const s = g;
      try {
        return g = this, t();
      } finally {
        g = s;
      }
    } else
      process.env.NODE_ENV !== "production" && R("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    ++this._on === 1 && (this.prevScope = g, g = this);
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    this._on > 0 && --this._on === 0 && (g = this.prevScope, this.prevScope = void 0);
  }
  stop(t) {
    if (this._active) {
      this._active = !1;
      let s, n;
      for (s = 0, n = this.effects.length; s < n; s++)
        this.effects[s].stop();
      for (this.effects.length = 0, s = 0, n = this.cleanups.length; s < n; s++)
        this.cleanups[s]();
      if (this.cleanups.length = 0, this.scopes) {
        for (s = 0, n = this.scopes.length; s < n; s++)
          this.scopes[s].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !t) {
        const i = this.parent.scopes.pop();
        i && i !== this && (this.parent.scopes[this.index] = i, i.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function Mt(e) {
  return new ke(e);
}
function et() {
  return g;
}
let u;
const ce = /* @__PURE__ */ new WeakSet();
class tt {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, g && g.active && g.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, ce.has(this) && (ce.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || me(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, Se(this), xe(this);
    const t = u, s = E;
    u = this, E = !0;
    try {
      return this.fn();
    } finally {
      process.env.NODE_ENV !== "production" && u !== this && R(
        "Active effect was not restored correctly - this is likely a Vue internal bug."
      ), Te(this), u = t, E = s, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        we(t);
      this.deps = this.depsTail = void 0, Se(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? ce.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    ue(this) && this.run();
  }
  get dirty() {
    return ue(this);
  }
}
let Ne = 0, C, $;
function me(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = $, $ = e;
    return;
  }
  e.next = C, C = e;
}
function ve() {
  Ne++;
}
function ge() {
  if (--Ne > 0)
    return;
  if ($) {
    let t = $;
    for ($ = void 0; t; ) {
      const s = t.next;
      t.next = void 0, t.flags &= -9, t = s;
    }
  }
  let e;
  for (; C; ) {
    let t = C;
    for (C = void 0; t; ) {
      const s = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (n) {
          e || (e = n);
        }
      t = s;
    }
  }
  if (e)
    throw e;
}
function xe(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function Te(e) {
  let t, s = e.depsTail, n = s;
  for (; n; ) {
    const i = n.prevDep;
    n.version === -1 ? (n === s && (s = i), we(n), st(n)) : t = n, n.dep.activeLink = n.prevActiveLink, n.prevActiveLink = void 0, n = i;
  }
  e.deps = t, e.depsTail = s;
}
function ue(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (Oe(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function Oe(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === z) || (e.globalVersion = z, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !ue(e))))
    return;
  e.flags |= 2;
  const t = e.dep, s = u, n = E;
  u = e, E = !0;
  try {
    xe(e);
    const i = e.fn(e._value);
    (t.version === 0 || x(i, e._value)) && (e.flags |= 128, e._value = i, t.version++);
  } catch (i) {
    throw t.version++, i;
  } finally {
    u = s, E = n, Te(e), e.flags &= -3;
  }
}
function we(e, t = !1) {
  const { dep: s, prevSub: n, nextSub: i } = e;
  if (n && (n.nextSub = i, e.prevSub = void 0), i && (i.prevSub = n, e.nextSub = void 0), process.env.NODE_ENV !== "production" && s.subsHead === e && (s.subsHead = i), s.subs === e && (s.subs = n, !n && s.computed)) {
    s.computed.flags &= -5;
    for (let r = s.computed.deps; r; r = r.nextDep)
      we(r, !0);
  }
  !t && !--s.sc && s.map && s.map.delete(s.key);
}
function st(e) {
  const { prevDep: t, nextDep: s } = e;
  t && (t.nextDep = s, e.prevDep = void 0), s && (s.prevDep = t, e.nextDep = void 0);
}
let E = !0;
const Ve = [];
function Ie() {
  Ve.push(E), E = !1;
}
function Me() {
  const e = Ve.pop();
  E = e === void 0 ? !0 : e;
}
function Se(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const s = u;
    u = void 0;
    try {
      t();
    } finally {
      u = s;
    }
  }
}
let z = 0;
class it {
  constructor(t, s) {
    this.sub = t, this.dep = s, this.version = s.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class be {
  // TODO isolatedDeclarations "__v_skip"
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(t) {
    if (!u || !E || u === this.computed)
      return;
    let s = this.activeLink;
    if (s === void 0 || s.sub !== u)
      s = this.activeLink = new it(u, this), u.deps ? (s.prevDep = u.depsTail, u.depsTail.nextDep = s, u.depsTail = s) : u.deps = u.depsTail = s, Pe(s);
    else if (s.version === -1 && (s.version = this.version, s.nextDep)) {
      const n = s.nextDep;
      n.prevDep = s.prevDep, s.prevDep && (s.prevDep.nextDep = n), s.prevDep = u.depsTail, s.nextDep = void 0, u.depsTail.nextDep = s, u.depsTail = s, u.deps === s && (u.deps = n);
    }
    return process.env.NODE_ENV !== "production" && u.onTrack && u.onTrack(
      le(
        {
          effect: u
        },
        t
      )
    ), s;
  }
  trigger(t) {
    this.version++, z++, this.notify(t);
  }
  notify(t) {
    ve();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let s = this.subsHead; s; s = s.nextSub)
          s.sub.onTrigger && !(s.sub.flags & 8) && s.sub.onTrigger(
            le(
              {
                effect: s.sub
              },
              t
            )
          );
      for (let s = this.subs; s; s = s.prevSub)
        s.sub.notify() && s.sub.dep.notify();
    } finally {
      ge();
    }
  }
}
function Pe(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let n = t.deps; n; n = n.nextDep)
        Pe(n);
    }
    const s = e.dep.subs;
    s !== e && (e.prevSub = s, s && (s.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
  }
}
const te = /* @__PURE__ */ new WeakMap(), I = Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), he = Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), B = Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function w(e, t, s) {
  if (E && u) {
    let n = te.get(e);
    n || te.set(e, n = /* @__PURE__ */ new Map());
    let i = n.get(s);
    i || (n.set(s, i = new be()), i.map = n, i.key = s), process.env.NODE_ENV !== "production" ? i.track({
      target: e,
      type: t,
      key: s
    }) : i.track();
  }
}
function N(e, t, s, n, i, r) {
  const o = te.get(e);
  if (!o) {
    z++;
    return;
  }
  const c = (a) => {
    a && (process.env.NODE_ENV !== "production" ? a.trigger({
      target: e,
      type: t,
      key: s,
      newValue: n,
      oldValue: i,
      oldTarget: r
    }) : a.trigger());
  };
  if (ve(), t === "clear")
    o.forEach(c);
  else {
    const a = T(e), p = a && _e(s);
    if (a && s === "length") {
      const _ = Number(n);
      o.forEach((f, d) => {
        (d === "length" || d === B || !F(d) && d >= _) && c(f);
      });
    } else
      switch ((s !== void 0 || o.has(void 0)) && c(o.get(s)), p && c(o.get(B)), t) {
        case "add":
          a ? p && c(o.get("length")) : (c(o.get(I)), j(e) && c(o.get(he)));
          break;
        case "delete":
          a || (c(o.get(I)), j(e) && c(o.get(he)));
          break;
        case "set":
          j(e) && c(o.get(I));
          break;
      }
  }
  ge();
}
function nt(e, t) {
  const s = te.get(e);
  return s && s.get(t);
}
function A(e) {
  const t = h(e);
  return t === e ? t : (w(t, "iterate", B), S(e) ? t : t.map(v));
}
function Ee(e) {
  return w(e = h(e), "iterate", B), e;
}
const rt = {
  __proto__: null,
  [Symbol.iterator]() {
    return ae(this, Symbol.iterator, v);
  },
  concat(...e) {
    return A(this).concat(
      ...e.map((t) => T(t) ? A(t) : t)
    );
  },
  entries() {
    return ae(this, "entries", (e) => (e[1] = v(e[1]), e));
  },
  every(e, t) {
    return D(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return D(this, "filter", e, t, (s) => s.map(v), arguments);
  },
  find(e, t) {
    return D(this, "find", e, t, v, arguments);
  },
  findIndex(e, t) {
    return D(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return D(this, "findLast", e, t, v, arguments);
  },
  findLastIndex(e, t) {
    return D(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return D(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return fe(this, "includes", e);
  },
  indexOf(...e) {
    return fe(this, "indexOf", e);
  },
  join(e) {
    return A(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return fe(this, "lastIndexOf", e);
  },
  map(e, t) {
    return D(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return W(this, "pop");
  },
  push(...e) {
    return W(this, "push", e);
  },
  reduce(e, ...t) {
    return ye(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return ye(this, "reduceRight", e, t);
  },
  shift() {
    return W(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return D(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return W(this, "splice", e);
  },
  toReversed() {
    return A(this).toReversed();
  },
  toSorted(e) {
    return A(this).toSorted(e);
  },
  toSpliced(...e) {
    return A(this).toSpliced(...e);
  },
  unshift(...e) {
    return W(this, "unshift", e);
  },
  values() {
    return ae(this, "values", v);
  }
};
function ae(e, t, s) {
  const n = Ee(e), i = n[t]();
  return n !== e && !S(e) && (i._next = i.next, i.next = () => {
    const r = i._next();
    return r.value && (r.value = s(r.value)), r;
  }), i;
}
const ot = Array.prototype;
function D(e, t, s, n, i, r) {
  const o = Ee(e), c = o !== e && !S(e), a = o[t];
  if (a !== ot[t]) {
    const f = a.apply(e, r);
    return c ? v(f) : f;
  }
  let p = s;
  o !== e && (c ? p = function(f, d) {
    return s.call(this, v(f), d, e);
  } : s.length > 2 && (p = function(f, d) {
    return s.call(this, f, d, e);
  }));
  const _ = a.call(o, p, n);
  return c && i ? i(_) : _;
}
function ye(e, t, s, n) {
  const i = Ee(e);
  let r = s;
  return i !== e && (S(e) ? s.length > 3 && (r = function(o, c, a) {
    return s.call(this, o, c, a, e);
  }) : r = function(o, c, a) {
    return s.call(this, o, v(c), a, e);
  }), i[t](r, ...n);
}
function fe(e, t, s) {
  const n = h(e);
  w(n, "iterate", B);
  const i = n[t](...s);
  return (i === -1 || i === !1) && St(s[0]) ? (s[0] = h(s[0]), n[t](...s)) : i;
}
function W(e, t, s = []) {
  Ie(), ve();
  const n = h(e)[t].apply(e, s);
  return ge(), Me(), n;
}
const ct = /* @__PURE__ */ Xe("__proto__,__v_isRef,__isVue"), Ae = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(F)
);
function at(e) {
  F(e) || (e = String(e));
  const t = h(this);
  return w(t, "has", e), t.hasOwnProperty(e);
}
class je {
  constructor(t = !1, s = !1) {
    this._isReadonly = t, this._isShallow = s;
  }
  get(t, s, n) {
    if (s === "__v_skip")
      return t.__v_skip;
    const i = this._isReadonly, r = this._isShallow;
    if (s === "__v_isReactive")
      return !i;
    if (s === "__v_isReadonly")
      return i;
    if (s === "__v_isShallow")
      return r;
    if (s === "__v_raw")
      return n === (i ? r ? $e : Ce : r ? We : Le).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(n) ? t : void 0;
    const o = T(t);
    if (!i) {
      let a;
      if (o && (a = rt[s]))
        return a;
      if (s === "hasOwnProperty")
        return at;
    }
    const c = Reflect.get(
      t,
      s,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      b(t) ? t : n
    );
    return (F(s) ? Ae.has(s) : ct(s)) || (i || w(t, "get", s), r) ? c : b(c) ? o && _e(s) ? c : c.value : H(c) ? i ? ze(c) : Ye(c) : c;
  }
}
class He extends je {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, s, n, i) {
    let r = t[s];
    if (!this._isShallow) {
      const a = M(r);
      if (!S(n) && !M(n) && (r = h(r), n = h(n)), !T(t) && b(r) && !b(n))
        return a ? !1 : (r.value = n, !0);
    }
    const o = T(t) && _e(s) ? Number(s) < t.length : ee(t, s), c = Reflect.set(
      t,
      s,
      n,
      b(t) ? t : i
    );
    return t === h(i) && (o ? x(n, r) && N(t, "set", s, n, r) : N(t, "add", s, n)), c;
  }
  deleteProperty(t, s) {
    const n = ee(t, s), i = t[s], r = Reflect.deleteProperty(t, s);
    return r && n && N(t, "delete", s, void 0, i), r;
  }
  has(t, s) {
    const n = Reflect.has(t, s);
    return (!F(s) || !Ae.has(s)) && w(t, "has", s), n;
  }
  ownKeys(t) {
    return w(
      t,
      "iterate",
      T(t) ? "length" : I
    ), Reflect.ownKeys(t);
  }
}
class Ke extends je {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, s) {
    return process.env.NODE_ENV !== "production" && R(
      `Set operation on key "${String(s)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, s) {
    return process.env.NODE_ENV !== "production" && R(
      `Delete operation on key "${String(s)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const ft = /* @__PURE__ */ new He(), lt = /* @__PURE__ */ new Ke(), ut = /* @__PURE__ */ new He(!0), ht = /* @__PURE__ */ new Ke(!0), pe = (e) => e, q = (e) => Reflect.getPrototypeOf(e);
function pt(e, t, s) {
  return function(...n) {
    const i = this.__v_raw, r = h(i), o = j(r), c = e === "entries" || e === Symbol.iterator && o, a = e === "keys" && o, p = i[e](...n), _ = s ? pe : t ? de : v;
    return !t && w(
      r,
      "iterate",
      a ? he : I
    ), {
      // iterator protocol
      next() {
        const { value: f, done: d } = p.next();
        return d ? { value: f, done: d } : {
          value: c ? [_(f[0]), _(f[1])] : _(f),
          done: d
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function X(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const s = t[0] ? `on key "${t[0]}" ` : "";
      R(
        `${Ze(e)} operation ${s}failed: target is readonly.`,
        h(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function dt(e, t) {
  const s = {
    get(i) {
      const r = this.__v_raw, o = h(r), c = h(i);
      e || (x(i, c) && w(o, "get", i), w(o, "get", c));
      const { has: a } = q(o), p = t ? pe : e ? de : v;
      if (a.call(o, i))
        return p(r.get(i));
      if (a.call(o, c))
        return p(r.get(c));
      r !== o && r.get(i);
    },
    get size() {
      const i = this.__v_raw;
      return !e && w(h(i), "iterate", I), Reflect.get(i, "size", i);
    },
    has(i) {
      const r = this.__v_raw, o = h(r), c = h(i);
      return e || (x(i, c) && w(o, "has", i), w(o, "has", c)), i === c ? r.has(i) : r.has(i) || r.has(c);
    },
    forEach(i, r) {
      const o = this, c = o.__v_raw, a = h(c), p = t ? pe : e ? de : v;
      return !e && w(a, "iterate", I), c.forEach((_, f) => i.call(r, p(_), p(f), o));
    }
  };
  return le(
    s,
    e ? {
      add: X("add"),
      set: X("set"),
      delete: X("delete"),
      clear: X("clear")
    } : {
      add(i) {
        !t && !S(i) && !M(i) && (i = h(i));
        const r = h(this);
        return q(r).has.call(r, i) || (r.add(i), N(r, "add", i, i)), this;
      },
      set(i, r) {
        !t && !S(r) && !M(r) && (r = h(r));
        const o = h(this), { has: c, get: a } = q(o);
        let p = c.call(o, i);
        p ? process.env.NODE_ENV !== "production" && Re(o, c, i) : (i = h(i), p = c.call(o, i));
        const _ = a.call(o, i);
        return o.set(i, r), p ? x(r, _) && N(o, "set", i, r, _) : N(o, "add", i, r), this;
      },
      delete(i) {
        const r = h(this), { has: o, get: c } = q(r);
        let a = o.call(r, i);
        a ? process.env.NODE_ENV !== "production" && Re(r, o, i) : (i = h(i), a = o.call(r, i));
        const p = c ? c.call(r, i) : void 0, _ = r.delete(i);
        return a && N(r, "delete", i, void 0, p), _;
      },
      clear() {
        const i = h(this), r = i.size !== 0, o = process.env.NODE_ENV !== "production" ? j(i) ? new Map(i) : new Set(i) : void 0, c = i.clear();
        return r && N(
          i,
          "clear",
          void 0,
          void 0,
          o
        ), c;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((i) => {
    s[i] = pt(i, e, t);
  }), s;
}
function ie(e, t) {
  const s = dt(e, t);
  return (n, i, r) => i === "__v_isReactive" ? !e : i === "__v_isReadonly" ? e : i === "__v_raw" ? n : Reflect.get(
    ee(s, i) && i in n ? s : n,
    i,
    r
  );
}
const _t = {
  get: /* @__PURE__ */ ie(!1, !1)
}, vt = {
  get: /* @__PURE__ */ ie(!1, !0)
}, gt = {
  get: /* @__PURE__ */ ie(!0, !1)
}, wt = {
  get: /* @__PURE__ */ ie(!0, !0)
};
function Re(e, t, s) {
  const n = h(s);
  if (n !== s && t.call(e, n)) {
    const i = De(e);
    R(
      `Reactive ${i} contains both the raw and reactive versions of the same object${i === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const Le = /* @__PURE__ */ new WeakMap(), We = /* @__PURE__ */ new WeakMap(), Ce = /* @__PURE__ */ new WeakMap(), $e = /* @__PURE__ */ new WeakMap();
function bt(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function Et(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : bt(De(e));
}
function Ye(e) {
  return M(e) ? e : ne(
    e,
    !1,
    ft,
    _t,
    Le
  );
}
function Pt(e) {
  return ne(
    e,
    !1,
    ut,
    vt,
    We
  );
}
function ze(e) {
  return ne(
    e,
    !0,
    lt,
    gt,
    Ce
  );
}
function At(e) {
  return ne(
    e,
    !0,
    ht,
    wt,
    $e
  );
}
function ne(e, t, s, n, i) {
  if (!H(e))
    return process.env.NODE_ENV !== "production" && R(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const r = Et(e);
  if (r === 0)
    return e;
  const o = i.get(e);
  if (o)
    return o;
  const c = new Proxy(
    e,
    r === 2 ? n : s
  );
  return i.set(e, c), c;
}
function Y(e) {
  return M(e) ? Y(e.__v_raw) : !!(e && e.__v_isReactive);
}
function M(e) {
  return !!(e && e.__v_isReadonly);
}
function S(e) {
  return !!(e && e.__v_isShallow);
}
function St(e) {
  return e ? !!e.__v_raw : !1;
}
function h(e) {
  const t = e && e.__v_raw;
  return t ? h(t) : e;
}
function jt(e) {
  return !ee(e, "__v_skip") && Object.isExtensible(e) && qe(e, "__v_skip", !0), e;
}
const v = (e) => H(e) ? Ye(e) : e, de = (e) => H(e) ? ze(e) : e;
function b(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function yt(e) {
  return Be(e, !1);
}
function Ht(e) {
  return Be(e, !0);
}
function Be(e, t) {
  return b(e) ? e : new Rt(e, t);
}
class Rt {
  constructor(t, s) {
    this.dep = new be(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = s ? t : h(t), this._value = s ? t : v(t), this.__v_isShallow = s;
  }
  get value() {
    return process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track(), this._value;
  }
  set value(t) {
    const s = this._rawValue, n = this.__v_isShallow || S(t) || M(t);
    t = n ? t : h(t), x(t, s) && (this._rawValue = t, this._value = n ? t : v(t), process.env.NODE_ENV !== "production" ? this.dep.trigger({
      target: this,
      type: "set",
      key: "value",
      newValue: t,
      oldValue: s
    }) : this.dep.trigger());
  }
}
function Dt(e) {
  return b(e) ? e.value : e;
}
const Nt = {
  get: (e, t, s) => t === "__v_raw" ? e : Dt(Reflect.get(e, t, s)),
  set: (e, t, s, n) => {
    const i = e[t];
    return b(i) && !b(s) ? (i.value = s, !0) : Reflect.set(e, t, s, n);
  }
};
function Kt(e) {
  return Y(e) ? e : new Proxy(e, Nt);
}
class mt {
  constructor(t, s, n) {
    this._object = t, this._key = s, this._defaultValue = n, this.__v_isRef = !0, this._value = void 0;
  }
  get value() {
    const t = this._object[this._key];
    return this._value = t === void 0 ? this._defaultValue : t;
  }
  set value(t) {
    this._object[this._key] = t;
  }
  get dep() {
    return nt(h(this._object), this._key);
  }
}
class xt {
  constructor(t) {
    this._getter = t, this.__v_isRef = !0, this.__v_isReadonly = !0, this._value = void 0;
  }
  get value() {
    return this._value = this._getter();
  }
}
function Lt(e, t, s) {
  return b(e) ? e : k(e) ? new xt(e) : H(e) && arguments.length > 1 ? Tt(e, t, s) : yt(e);
}
function Tt(e, t, s) {
  const n = e[t];
  return b(n) ? n : new mt(e, t, s);
}
class Ot {
  constructor(t, s, n) {
    this.fn = t, this.setter = s, this._value = void 0, this.dep = new be(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = z - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !s, this.isSSR = n;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    u !== this)
      return me(this, !0), !0;
    process.env.NODE_ENV;
  }
  get value() {
    const t = process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    return Oe(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter ? this.setter(t) : process.env.NODE_ENV !== "production" && R("Write operation failed: computed value is readonly");
  }
}
function Wt(e, t, s = !1) {
  let n, i;
  k(e) ? n = e : (n = e.get, i = e.set);
  const r = new Ot(n, i, s);
  return process.env.NODE_ENV !== "production" && t && !s && (r.onTrack = t.onTrack, r.onTrigger = t.onTrigger), r;
}
const Z = {}, se = /* @__PURE__ */ new WeakMap();
let V;
function Vt(e, t = !1, s = V) {
  if (s) {
    let n = se.get(s);
    n || se.set(s, n = []), n.push(e);
  } else
    process.env.NODE_ENV !== "production" && !t && R(
      "onWatcherCleanup() was called when there was no active watcher to associate with."
    );
}
function Ct(e, t, s = Fe) {
  const { immediate: n, deep: i, once: r, scheduler: o, augmentJob: c, call: a } = s, p = (l) => {
    (s.onWarn || R)(
      "Invalid watch source: ",
      l,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, _ = (l) => i ? l : S(l) || i === !1 || i === 0 ? m(l, 1) : m(l);
  let f, d, K, G, J = !1, U = !1;
  if (b(e) ? (d = () => e.value, J = S(e)) : Y(e) ? (d = () => _(e), J = !0) : T(e) ? (U = !0, J = e.some((l) => Y(l) || S(l)), d = () => e.map((l) => {
    if (b(l))
      return l.value;
    if (Y(l))
      return _(l);
    if (k(l))
      return a ? a(l, 2) : l();
    process.env.NODE_ENV !== "production" && p(l);
  })) : k(e) ? t ? d = a ? () => a(e, 2) : e : d = () => {
    if (K) {
      Ie();
      try {
        K();
      } finally {
        Me();
      }
    }
    const l = V;
    V = f;
    try {
      return a ? a(e, 3, [G]) : e(G);
    } finally {
      V = l;
    }
  } : (d = Ge, process.env.NODE_ENV !== "production" && p(e)), t && i) {
    const l = d, y = i === !0 ? 1 / 0 : i;
    d = () => m(l(), y);
  }
  const re = et(), P = () => {
    f.stop(), re && re.active && Je(re.effects, f);
  };
  if (r && t) {
    const l = t;
    t = (...y) => {
      l(...y), P();
    };
  }
  let O = U ? new Array(e.length).fill(Z) : Z;
  const L = (l) => {
    if (!(!(f.flags & 1) || !f.dirty && !l))
      if (t) {
        const y = f.run();
        if (i || J || (U ? y.some((oe, Q) => x(oe, O[Q])) : x(y, O))) {
          K && K();
          const oe = V;
          V = f;
          try {
            const Q = [
              y,
              // pass undefined as the old value when it's changed for the first time
              O === Z ? void 0 : U && O[0] === Z ? [] : O,
              G
            ];
            O = y, a ? a(t, 3, Q) : (
              // @ts-expect-error
              t(...Q)
            );
          } finally {
            V = oe;
          }
        }
      } else
        f.run();
  };
  return c && c(L), f = new tt(d), f.scheduler = o ? () => o(L, !1) : L, G = (l) => Vt(l, !1, f), K = f.onStop = () => {
    const l = se.get(f);
    if (l) {
      if (a)
        a(l, 4);
      else
        for (const y of l)
          y();
      se.delete(f);
    }
  }, process.env.NODE_ENV !== "production" && (f.onTrack = s.onTrack, f.onTrigger = s.onTrigger), t ? n ? L(!0) : O = f.run() : o ? o(L.bind(null, !0), !0) : f.run(), P.pause = f.pause.bind(f), P.resume = f.resume.bind(f), P.stop = P, P;
}
function m(e, t = 1 / 0, s) {
  if (t <= 0 || !H(e) || e.__v_skip || (s = s || /* @__PURE__ */ new Set(), s.has(e)))
    return e;
  if (s.add(e), t--, b(e))
    m(e.value, t, s);
  else if (T(e))
    for (let n = 0; n < e.length; n++)
      m(e[n], t, s);
  else if (Ue(e) || j(e))
    e.forEach((n) => {
      m(n, t, s);
    });
  else if (Qe(e)) {
    for (const n in e)
      m(e[n], t, s);
    for (const n of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, n) && m(e[n], t, s);
  }
  return e;
}
export {
  B as ARRAY_ITERATE_KEY,
  ke as EffectScope,
  I as ITERATE_KEY,
  he as MAP_KEY_ITERATE_KEY,
  tt as ReactiveEffect,
  Wt as computed,
  Mt as effectScope,
  et as getCurrentScope,
  St as isProxy,
  Y as isReactive,
  M as isReadonly,
  b as isRef,
  S as isShallow,
  jt as markRaw,
  Vt as onWatcherCleanup,
  Ie as pauseTracking,
  Kt as proxyRefs,
  Ye as reactive,
  A as reactiveReadArray,
  ze as readonly,
  yt as ref,
  Me as resetTracking,
  Pt as shallowReactive,
  Ee as shallowReadArray,
  At as shallowReadonly,
  Ht as shallowRef,
  h as toRaw,
  v as toReactive,
  de as toReadonly,
  Lt as toRef,
  w as track,
  m as traverse,
  N as trigger,
  Dt as unref,
  Ct as watch
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@vue_reactivity@3.5.18/~/@vue/reactivity/dist/reactivity.esm-bundler.js
// module id = 2
// module chunks = 41